import React from 'react';
import { Container, Typography } from '@material-ui/core';
import Copyright from '../../Components/Copyright';

// import { Container } from './styles';

function Footer() {
  return (
    <Container maxWidth="sm">
        <Typography align="center" style={{ fontWeight: 'bold' }}>
            SMTI
        </Typography>
        <Typography align="center" style={{ fontSize: '0.8em' }}>
            Superintendência Municipal de Tecnologia da Informação
        </Typography>
        <Copyright />
    </Container>
  );
}

export default Footer;